export default __webpack_public_path__ + "b0f92dd0970903bb8c421d2e2aa06b29.png";